export default __webpack_public_path__ + "static/media/Quickie + NoBS.31d91744.png";